import React from "react";
import "./crm-layout.css";

/**
 * Unified CRM page wrapper — consistent spacing, max-width, and theme
 * across list, detail, and analytics views.
 */
const CrmPageShell = ({ children, variant = "default", className = "" }) => {
  const variantClass =
    variant === "detail"
      ? "crm-page-shell--detail"
      : variant === "analytics"
        ? "crm-page-shell--analytics"
        : "";

  return (
    <div className={`crm-page-shell ${variantClass} ${className}`.trim()}>
      {children}
    </div>
  );
};

export default CrmPageShell;
